import { TransporterCardBottomSection as TransporterCardBottomSectionTypes } from "@vahak/core/dist/custom-types/cards";

/** Profile CTA removed from transport directory. Contact CTA is currently unused. */
const TransporterCardBottomSection = (_props: TransporterCardBottomSectionTypes) => {
    return null;
};

export default TransporterCardBottomSection;
